const env = process.env.NODE_ENV  || 'production';

let config = {
    production : {
        url: 'https://api.juphy.com',
        api: {
            url: 'https://api.juphy.com'
        },
        apiV2: {
          url: 'https://api-v2.juphy.com',
        },
        iframe: {
            url: 'https://ai.juphy.com'
        },
        juphyVuex: {
          url: 'https://app.juphy.com'
        },
        juphyWidget: {
          url: 'https://widget.juphy.com'
        },
        name: 'production'
    },
    staging : {
        url: 'https://staging-api.juphy.com/',
        api: {
            url: 'https://staging-api.juphy.com/'
        },
        apiV2: {
          url: 'http://localhost:3000',
        },
        iframe: {
            url: 'https://ai.juphy.com'
        },
        juphyVuex: {
          url: 'http://localhost:3333'
        },
        juphyWidget: {
          url: 'http://localhost:8080'
        },
        name:'staging'
    },
    development : {
        url: 'https://api.juphy.com',
        api: {
            url: 'https://api.juphy.com'
        },
        iframe: {
            url: 'http://localhost:5173'
        },
        apiV2: {
          url: 'http://localhost:3000',
        },
        juphyVuex: {
          url: 'http://localhost:3333'
        },
        juphyWidget: {
          url: 'http://localhost:8080'
        },
        name:'development'
    }
 }

export default config[env]